import { AfterContentInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { VideoComponentBase } from '../../../../../models/video-component.base.interface';
import { VideoEventType } from '../../../../../models/video-event-type.enum';
import { BunnyTimeData } from '../../models/bunny-time-data.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VideoPlayerBaseComponent } from '../../../base/video-player-base.component';
import { DwConfigService, DwConfigServiceToken, DwLoggingService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { VideoMessagingService } from '../../../../../services/video-messaging.service';
import { Observable, Subscription } from 'rxjs';
import { DwPubSubService } from '../../../../../../z-devware/pubsub/dw-pub-sub-service';
import { DwClientSessionUtilService } from '../../../../../../z-devware/pubsub/dw-client-session-util.service';

@Component({
  selector: 'app-video-player-bunny-new',
  templateUrl: './video-player-bunny-new.component.html',
  styleUrls: ['./video-player-bunny-new.component.scss']
})
export class VideoPlayerBunnyNewComponent extends VideoPlayerBaseComponent implements VideoComponentBase, AfterContentInit, OnDestroy {
  videoUrl: string;
  videoUrlSafe: SafeUrl;
  private static videoBroadcastChannel: BroadcastChannel = null;

  @ViewChild('iframe') playerIframe: HTMLIFrameElement;
  startTime: number;
  player: any;
  playerStats: any = {};
  initTimeSeconds: number;
  dupEventList: any = {};
  recovering: boolean = false;
  
  constructor(dwSecurityUserService: DwSecurityUserService, videoMessagingService: VideoMessagingService, dwPubSubService: DwPubSubService,
    @Inject(DwConfigServiceToken) private dwConfigService: DwConfigService, private sanitizer: DomSanitizer, private hostElementRef: ElementRef, private dwLoggingService: DwLoggingService) {
    super(dwSecurityUserService, videoMessagingService, dwPubSubService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  setupVideo(): void {
    this.startTime = performance.now();

    super.setupVideo();

    const videoKey = this.video?.VideoKey;
    const videoLibraryKey = this.videoLibrary?.VideoLibraryKey;

    if (!videoKey) {
      return;
    }

    // this didn't look like it will change so didn't make it a configurable option
    const responsive = true;

    const cacheBust = `${Date.now()}-${DwClientSessionUtilService.generateUuid()}`;
    //this.videoUrl = `${this.video?.DirectPlayUrl.replace('/play', '/embed')}?autoplay=${this.videoStreamingProvider.AutoPlay}&loop=false&muted=false&preload=${this.videoStreamingProvider.PreloadVideo}&responsive=${responsive}&cacheBust=${encodeURIComponent(cacheBust)}`;
    this.videoUrl = `${this.video?.DirectPlayUrl.replace('/play', '/embed')}?cacheBust=${encodeURIComponent(cacheBust)}`;
    
    
    this.videoUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);

    //console.log('Setup video complete');
  }

  ngAfterContentInit(): void {
    // this.setupIframe();
    // console.log('After content init');

    // this.setupPlayer();


  } 

  async onIframeLoad() {
    //console.log('I-frame loaded event');
    this.setupIframe();

     const src = this.playerIframe.getAttribute('src') || '';
    const srcProp = this.playerIframe.src || '';

    this.dwPubSubService.emitDebug('Info', 'PJS - Iframe load', { src, srcProp });

    // Ignore placeholder loads
    if (!srcProp || srcProp === 'about:blank') return;

    this.setupPlayer();
  }


  private setupIframe() {

    if (this.playerIframe && this.videoUrl) {
      return;
    }

    const iFrame = document.getElementById("bunny-stream-embed") as HTMLIFrameElement;

    this.playerIframe = iFrame;
  }

  setupPlayer() {
    if (this.player) {
      return;
    }

    if (!this.playerIframe) {

      this.dwLoggingService.logWarning('Bunny.net player - Could not find player iframe element', null, true);
      return;
    }

    if (!this.videoUrl) {
      this.dwLoggingService.logWarning('Bunny.net player - Video URL not set yet', null, true);
      return;
    }

    const playerJs = (window as any).playerjs;

    if (!playerJs) {
      return;
    }

    try {
      this.player = new playerJs.Player(this.playerIframe);
    } catch (error) {
      this.dwPubSubService.emitDebug('Warn', 'PJS - error creating', { ...this.playerStats, error });
      this.dwLoggingService.logError('Bunny.net player - Error creating Playerjs instance', error);
      return;
    }

    this.playerStats.playerSetupCount += 1;

    this.dwPubSubService.emitDebug('Info', 'PJS - Player setup', { ...this.playerStats });

    this.setupPlayerJsEvents();
  }

  private teardownPlayer() {
    try { this.player?.off?.('play'); } catch { }
    try { this.player?.off?.('pause'); } catch { }
    try { this.player?.off?.('ended'); } catch { }
    try { this.player?.off?.('timeupdate'); } catch { }
    try { this.player?.off?.('ready'); } catch { }
    try { this.player = null; } catch { }
  }

  private setupPlayerJsEvents() {
    if (!this.player) {
      return;
    }

    this.initVideoPlayer();

    this.player.on('play', (data) => {

      this.dedupeAndInvoke('play', () => this.onPlay(false));

    });

    this.player.on('pause', (data) => {
      this.dedupeAndInvoke('pause', () => this.onPause(false));
    });

    this.player.on('error', (error) => {
      this.dwPubSubService.emitDebug('Error', 'PJS - Player js error', error);
      this.dwLoggingService.logError('Bunny.net player - Player js error event', error);
    });

    this.player.on('ended', (data) => {
      this.playerStats.completed++;

      this.onVideoEvent(VideoEventType.videoCompleted, { ...this.playerStats });
    });

    this.player.on('timeupdate', (timeData: BunnyTimeData) => {
      this.playerStats.timeUpdate++;
      const timeUpdateResult = this.updateCurrentTime(timeData.seconds);

      if (timeUpdateResult.userSeeked) {
        this.player.setCurrentTime(this.furthestWatchedTime);
      }

      this.onVideoEvent(VideoEventType.videoProgress, this.playerStats);
    });

    this.player.on("ready", this.onReady.bind(this));
  }

  private onPlay(manual: boolean) {
    if (manual) {
      this.playerStats.manualStarted++;

      if (this.playerStats.started > 0) {
        return;
      }

      //('Manual play', { ...this.playerStats });
    } else {
      this.playerStats.started++;

      //console.log('PJS play', { ...this.playerStats });
    }

    this.onVideoEvent(VideoEventType.videoStarted, this.playerStats);

    this.notifyVideoStarted();
  }

  private onPause(manual: boolean) {
    if (manual) {
      this.playerStats.manualPaused++;

      if (this.playerStats.paused > 0) {
        return;
      }

      //console.log('Manual pause', { ...this.playerStats });
    } else {
      this.playerStats.paused++;

      //console.log('PJS pause', { ...this.playerStats });
    }

    this.onVideoEvent(VideoEventType.videoPaused, this.playerStats);
  }

  private onReady() {
    this.onVideoEvent(VideoEventType.onReady, this.playerStats);

    this.initVideoPlayer();
  }

  initComplete = false;

  initVideoPlayer() {

    if (this.initComplete) {

      return;
    }

    //this.setupVideoStateChecks();

    if (!this.player.isReady) {
      this.dwPubSubService.emitDebug('Warn', 'PJS - Not ready', { ...this.playerStats });
      setTimeout(() =>
        this.setupVideoStartOptions(), 100);

      return;
    }

    const initTime = performance.now() - this.startTime;

    this.playerStats.initTime = Math.round(initTime);

    this.initCompleted.emit(true);

    this.initTimeSeconds = Math.round(initTime / 100) / 10;

    this.dwPubSubService.emitDebug('Warn', `PJS - Init complete ${this.initTimeSeconds}s`, { ...this.playerStats });

    this.playerStats.initComplete = true;

    this.player.getDuration((duration) => {
      this.videoDuration = duration;

      if (this.videoDuration > 0) {
        this.initComplete = true;


        this.setupVideoStartOptions();
        return;
      }

      setTimeout(() => {
        this.initVideoPlayer();
      }, 100);
    });

  }

  setupVideoStartOptions() {
  
  }

  pauseVideo() {
    if (!this.player) {
      this.dwPubSubService.emitDebug('Info', `BP - this.player is null`, { ...this.playerStats });
      return;
    }

    this.dwPubSubService.emitDebug('Info', `PJS Pause`, { ...this.playerStats });

    this.player.pause();
  }


  playVideo() {
    if (!this.player) {
      this.dwPubSubService.emitDebug('Info', `BP - this.player is null`, { ...this.playerStats });
      return;
    }

    this.dwPubSubService.emitDebug('Info', `PJS Play`, { ...this.playerStats });

    this.player.play();
  }



  private dedupeAndInvoke<T>(
    eventName: string,
    //value: T,
    invoke: () => void,
    options?: {
      windowMs?: number;          // default 300ms
      compare?: (a: T, b: T) => boolean; // custom equality
      logPrefix?: string;         // for debug labeling
    }
  ): void {
    const now = Date.now();
    const windowMs = options?.windowMs ?? 300;
    const compare = options?.compare ?? ((a, b) => a === b);
    const label = options?.logPrefix ?? 'Player.Dedupe';

    const entry = this.dupEventList[eventName];

    // First occurrence → always allow
    if (!entry) {
      this.dupEventList[eventName] = {
        lastEmitMs: now,
        //lastValue: value
      };

      //this.dwPubSubService.emitDebug('Info', `${label}.${eventName}.First`, {  });
      invoke();
      return;
    }

    // Time-window dedupe
    const deltaMs = now - entry.lastEmitMs;
    if (deltaMs < windowMs) {
      this.dwPubSubService.emitDebug(
        'Warn',
        `${label}.${eventName}.Skip`,
        { deltaMs, windowMs }
      );
      return;
    }

    // Accept
    entry.lastEmitMs = now;

    invoke();
  }
}

function safeTrim(data: string, maxLength: number = 512): any {

  if (data?.length > maxLength) {
    return `${data.substring(0, maxLength)}... (truncated)`;
  }

  return data;

}
